import { render, staticRenderFns } from "./dianLiXiangXi.vue?vue&type=template&id=1a437b40&scoped=true&"
import script from "./dianLiXiangXi.vue?vue&type=script&lang=js&"
export * from "./dianLiXiangXi.vue?vue&type=script&lang=js&"
import style0 from "./dianLiXiangXi.vue?vue&type=style&index=0&id=1a437b40&prod&lang=scss&"
import style1 from "./dianLiXiangXi.vue?vue&type=style&index=1&id=1a437b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a437b40",
  null
  
)

export default component.exports